import { fetchPath } from "../api/chatbot";
import {
  Coordinate,
  DEFAULT_MAP_ID,
  DEFAULT_VENUE_ID,
} from "../types/coordinate";
import { NavigationData, NavigationDataResponse } from "../types/navigation";
import { getVenue, getVenueMapId } from "./map-util";
import * as THREE from "three";

export function isLift(pathType: number) {
  return pathType === 6 || pathType === 7;
}
export function isEscalator(pathType: number | null) {
  return pathType === 2 || pathType === 3;
}

export interface NavigationParams {
  userQuery: string;
  conversationId?: string;
  traceId?: string;
  userId: string;
  venueId: string;
  userLocation?: Coordinate;
  mapId: string;
  is_disability: string;
  lang: string;
  startPoi?: string;
}

export interface NavigationResult {
  success: boolean;
  projectId?: string;
  data?: NavigationDataResponse;// NavigationData;
  error?: string;
}

/**
 *  This function handles getting the current position and finding the navigation path
 */
export const findNavPath = async (
  lang: string,
  userQuery: string,
  mode: string,
  userId: string,
  // conversationId: string,
  traceId: string,
  coordinate: Coordinate,
  options?: {
    startVenueId?: string;
    startMapId?: string;
    startCoordinate?: string;
    startPoi?: string;
    onChatUpdate?: (chunk: string) => void,
  }
): Promise<NavigationResult> => {
  try {
    const venueInfo = getVenue(coordinate.lat, coordinate.lng);
    console.log("venueInfo:", venueInfo);

    var venueId =
      venueInfo?.projectId?.toString() ?? DEFAULT_VENUE_ID.toString();
    var mapId = venueInfo?.entry_mapId?.toString() ?? DEFAULT_MAP_ID.toString();
    var coordinateParam = coordinate;
    console.log("findPath options", options);
    // if start position is provided, no need to call identify-location API
    if (
      options &&
      options.startVenueId !== undefined &&
      options.startVenueId !== "" &&
      options.startMapId !== undefined &&
      options.startMapId !== "" &&
      options.startCoordinate !== undefined &&
      options.startCoordinate !== "" &&
      options.startPoi !== undefined &&
      options.startPoi !== ""
    ) {
      const coord = options.startCoordinate.split(",");
      coordinateParam = {
        lat: Number(coord[0]),
        lng: Number(coord[1]),
      };
      mapId = options.startMapId
      venueId = options.startVenueId
      console.log("using startPOI", coordinateParam, mapId, venueId);
    }
    // else if (venueId) {
    //       try {
    //         const startPoi = await findStartPoi(userQuery, venueId, traceId);
    //         console.log("startPoi", startPoi);
    //         if (startPoi.poi_found.length > 0) {
    //           coordinateParam = {
    //             lat: Number(startPoi.poi_found[0].lat),
    //             lng: Number(startPoi.poi_found[0].lng),
    //           };
    //           mapId = getVenueMapId(venueId, startPoi.poi_found[0].level) ?? "-1";
    //           console.log("mapId", mapId);
    //         }
    //       } catch (e) {
    //         console.error("Error encountered when finding starting POI", e);
    //       }
    //     }
    const controller = new AbortController();
    const response = await fetchPath({
      userQuery,
      // conversationId: conversationId,
      traceId: traceId,
      userId: userId,
      venueId: venueId,
      userLocation: coordinateParam,
      mapId: mapId,
      is_disability: mode === "walk" || mode === "drone" ? "0" : "1",
      lang: lang,
      startPoi: options?.startPoi
    },
      options?.onChatUpdate,
      controller)

    // const response = await findPath({
    //   userQuery,
    //   conversationId: conversationId,
    //   traceId: traceId,
    //   userId: userId,
    //   venueId: venueId,
    //   userLocation: coordinateParam,
    //   mapId: mapId,
    //   is_disability: mode === "walk" || mode === "drone" ? "0" : "1",
    //   lang: lang,
    // });
    console.log("fetchPath response", response)
    return {
      success: true,
      projectId: venueId,
      data: response,
    };
  } catch (error) {
    console.error("Error finding navigation path:", error);
    return {
      success: false,
      error: error instanceof Error ? error.message : "Unknown error occurred",
    };
  }
};

export function getYAngleDegree(fromVec: THREE.Vector3, toVec: THREE.Vector3) {
  const direction = new THREE.Vector3().subVectors(toVec, fromVec);
  direction.y = 0;
  direction.normalize();
  // const reference = new THREE.Vector3(0, 0, 1);
  const angleRad = Math.atan2(direction.x, direction.z);
  const angleDeg = THREE.MathUtils.radToDeg(angleRad);
  return angleDeg.toFixed(2);
}

export function interpolateVector3Array(points: any[], percentage: number) {
  if (percentage <= 0) return points[0];
  if (percentage >= 1) return points[points.length - 1];
  const segments = points.length - 1;
  const scaledPosition = percentage * segments;
  const segmentIndex = Math.floor(scaledPosition);
  const segmentFraction = scaledPosition - segmentIndex;
  const start = points[segmentIndex];
  const end = points[segmentIndex + 1];
  const result = [
    start[0] + (end[0] - start[0]) * segmentFraction,
    start[1] + (end[1] - start[1]) * segmentFraction,
    start[2] + (end[2] - start[2]) * segmentFraction,
  ];
  return result;
}
